import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import LoginGate from "./components/LoginGate";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Match the old admin's 15s auto-refresh feel. Background refetch keeps
      // dashboards live while users have the tab open.
      staleTime: 10_000,
      refetchInterval: 15_000,
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* basename matches Vite `base: /tradingview/admin/` so server-side
          nginx and client-side router stay in sync. */}
      <BrowserRouter basename="/tradingview/admin">
        <LoginGate>
          <App />
        </LoginGate>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
